
      // Override robots and canonical via Vite env when provided
      const robots = import.meta.env.VITE_ROBOTS_DIRECTIVE;
      const canonical = import.meta.env.VITE_CANONICAL_URL;
      try {
        if (robots) {
          const robotsMeta = document.querySelector('meta[name="robots"]');
          if (robotsMeta) robotsMeta.setAttribute('content', robots);
        }
        if (canonical) {
          const canonicalLink = document.querySelector('link[rel="canonical"]');
          if (canonicalLink) canonicalLink.setAttribute('href', canonical);
        }
      } catch (e) {
        console.warn('SEO env override failed:', e);
      }
    